/* jshint -W024 */
// landing script extends base script
import "./base";

import "./app/eros/common/landing/sideNavi";
import "./app/eros/common/landing/smoothScroll";

import CustomTooltip from "./app/eros/components/common/CustomTooltip.vue";
Vue.component("custom-tooltip", CustomTooltip);

Vue.component("progress-indicator", () => import("./app/eros/components/common/ProgressIndicator.vue"));